import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

/** Extracts base url of client side application */
@Injectable()
export class BaseUrlService {
    public baseUrl: string;

    constructor(private location: Location) {
        this.init();
    }

    private init(): void {
        const base = window.location.origin + this.location.prepareExternalUrl('/');
        this.baseUrl = base.charAt(base.length - 1) === '/' ? base.slice(0, -1) : base;
    }
}
